import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Button, Form, Input, message, Space, Spin } from 'udesk-ui';
import { FormWrapper, Logo, TipWrapper, Wrapper } from './components';
import Authorization from 'Component/pages/system-integration/components/Authorization';
import { getAiAgentConfigsMy } from 'src/api/aiAgentConfigs/my';
import { postAiAgentConfigsCoze } from 'src/api/aiAgentConfigs/coze';
import { getAiAgentConfigsCozeCallback } from 'src/api/aiAgentConfigs/coze/callback';
import { deleteAiAgentConfigsCancelById } from 'src/api/aiAgentConfigs/cancel/{id}';
import { AiAgentConfigCreateRequest } from 'src/api/types';

interface FormValues extends Pick<AiAgentConfigCreateRequest, 'clientId' | 'secretKey'> {}

interface TempalteProps {}

const Tempalte: FC<TempalteProps> = memo((props) => {
    const locales = UdeskLocales['current'];

    const [form] = Form.useForm();

    const [initFormValues, setInitFormValues] = useState<FormValues>();

    const [authorized, setAuthorized] = useState(false);

    const [curId, setId] = useState<number>();

    const {
        run: refresh,
        loading: getLoading,
        data,
    } = useRequest(() => getAiAgentConfigsMy({}), {
        onSuccess: (res) => {
            setAuthorized(res.data?.status === 1);
            setInitFormValues({
                clientId: res.data?.clientId,
                secretKey: res.data?.secretKey,
            });
            setId(res.data?.id);
            form.resetFields();
        },
    });

    const { run: onFinish, loading: saveLoading } = useRequest(
        (values: FormValues) => postAiAgentConfigsCoze({ ...values, id: data?.data?.id }),
        {
            manual: true,
            onSuccess: (res) => {
                if (res.data) {
                    window.open(res.data, '_blank');
                }
            },
        }
    );

    const query = new URLSearchParams(window.location.search);
    const code = query.get('code');
    const state = query.get('state');

    const { loading: authLoading } = useRequest(
        () => getAiAgentConfigsCozeCallback({ params: { code: code!, state: state! } }),
        {
            ready: !!code && !!state,
            onSuccess: () => {
                message.success(
                    /* 授权成功 */ UdeskLocales['current'].pages.systemIntegration.zendesk
                        .components.chat.index.authorizationSucceeded
                );
                refresh();
            },
        }
    );

    const { run: cancelAuth, loading: putLoading } = useRequest(
        () => deleteAiAgentConfigsCancelById({ segments: { id: curId! } }),
        {
            manual: true,
            ready: !!curId,
            onSuccess: () => {
                message.success(
                    /* 取消授权成功 */ UdeskLocales['current'].pages.systemIntegration.zendesk
                        .components.chat.index.cancelAuthorizationSuccessfully
                );
                refresh();
            },
        }
    );

    return (
        <Wrapper>
            <TipWrapper>
                <Authorization authorized={authorized} />
            </TipWrapper>

            <Spin spinning={getLoading || saveLoading || authLoading || putLoading}>
                <FormWrapper>
                    <Logo className="logo">
                        <img src="/static/images/coze.svg" alt="" style={{ width: '100%' }} />
                    </Logo>

                    <Form
                        form={form}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 10 }}
                        initialValues={initFormValues}
                        onFinish={onFinish}
                        style={{ flex: 1 }}
                    >
                        <Form.Item
                            name="clientId"
                            label={
                                /* 客户端ID */ UdeskLocales['current'].pages.systemIntegration
                                    .zendesk.components.chat.index.clientID
                            }
                        >
                            <Input maxLength={200} disabled={authorized} />
                        </Form.Item>

                        <Form.Item
                            name="secretKey"
                            label={
                                /* 客户端密钥 */ UdeskLocales['current'].pages.systemIntegration
                                    .zendesk.components.chat.index.clientKey
                            }
                        >
                            <Input maxLength={200} disabled={authorized} />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 5, span: 10 }}>
                            {!authorized ? (
                                <Space>
                                    <Button key="applyAuth" type="primary" htmlType="submit">
                                        {locales.pages.admin.systemIntegration.applyAuth}
                                    </Button>
                                </Space>
                            ) : (
                                <Space>
                                    <Button key="cancelAuth" onClick={() => cancelAuth()}>
                                        {locales.pages.admin.systemIntegration.cancelAuth}
                                    </Button>
                                </Space>
                            )}
                        </Form.Item>
                    </Form>
                </FormWrapper>
            </Spin>
        </Wrapper>
    );
});

export default Tempalte;
